module.exports = __webpack_public_path__ + "img/fixed_door.33b1f965.svg";